import React, { useState, Fragment } from "react";
import HoverIconButton from "components/HoverIconButton";
import { useFieldFocusRef } from "utils/hooks";
import { COLORS } from "utils/styles";
import ConnectedTextarea from "components/ConnectedTextarea";
import { useFormikContext } from "formik";
import SelectField from "components/SelectField";
import { SHORT_LINK_STATUS_OPTIONS } from "utils/constants/shortLink";
import SectionBezel from "components/SectionBezel";

const DetailsFields = ({ focusFirst, title }) => {
  const { values } = useFormikContext();
  const editMode = Boolean(values.id);
  const [showFields, setShowFields] = useState(editMode);
  const titleRef = useFieldFocusRef();

  const titleProps = {
    name: "title",
    label: "Name",
    minRows: 1,
    ...title
  };
  if (focusFirst) {
    titleProps.innerRef = titleRef;
  }

  const actionComp = (
    <HoverIconButton
      onClick={() => setShowFields(!showFields)}
      tooltip={showFields ? "Hide fields" : "Show more fields"}
      color={showFields ? COLORS.blue : COLORS.primary}
      type={showFields ? "eye" : "eyeClosed"}
    />
  );

  return (
    <SectionBezel header="Details" action={actionComp}>
      <Fragment>
        <div className="pb3">
          <ConnectedTextarea {...titleProps} />
        </div>
        {editMode && showFields && (
          <div className="pb3">
            <SelectField
              name="status"
              label="Status"
              options={SHORT_LINK_STATUS_OPTIONS}
              customClasses={{ label: "field__label fw5 db" }}
            />
          </div>
        )}
        {showFields && (
          <ConnectedTextarea
            name="description"
            label="Description"
            minRows={1}
          />
        )}
      </Fragment>
    </SectionBezel>
  );
};

export default DetailsFields;
